window.addEventListener("DOMContentLoaded", () => {

  const titleDocumentElem = document.querySelector("#document-title"),
        titleDocument = titleDocumentElem.getAttribute("data-document-title"),
        uiGenerateBtn = document.querySelector("#btn-generate-pdf"),
        btnStateInactive = uiGenerateBtn.querySelector("#btn-generate-pdf-inactive"),
        btnStateActive = uiGenerateBtn.querySelector("#btn-generate-pdf-active");

  uiGenerateBtn.addEventListener("click", async (event) => {

    event.preventDefault();

    const pageToPdf = window.location.href;
    const title = `${titleDocument}.pdf` || `${document.title}.pdf`;
    
    const options = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ 
        pageToPdf, 
        title
      }),
    };

    // Display loading state
    uiGenerateBtn.classList.add("pointer-events-none");
    btnStateInactive.classList.add("hidden");
    btnStateActive.classList.remove("hidden");

    try {
      const response = await fetch("/api/generate-pdf/", options);

      if (!response.ok) {
        throw new Error(`Server error: ${response.statusText}`);
      }

      // Handle response as binary
      const pdfBlob = await response.blob();

      // Create a download link for the PDF
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const downloadLink = document.createElement("a");
      downloadLink.href = pdfUrl;
      downloadLink.download = title;
      downloadLink.click();

      URL.revokeObjectURL(pdfUrl); // Clean up memory
    } catch (error) {
      console.error("Failed to download PDF:", error);
      alert("An error occurred while generating the PDF. Please try again.");
    } finally {
      // Reset button state
      uiGenerateBtn.classList.remove("pointer-events-none");
      btnStateInactive.classList.remove("hidden");
      btnStateActive.classList.add("hidden");
    }

  });

  // Data feedback form

  // const feedbackBtn =  document.querySelector("#feedback-button"),
  //       feedbackCancelBtn =  document.querySelector("#feedback-cancel-btn"),
  //       feedbackWrapper = document.querySelector("#feedback-wrapper"),
  //       feedbackForm = document.querySelector("#feedback"),
  //       feedbackUser = document.querySelector("#feedback-user"),
  //       msgSuccess = document.querySelector("#msg-feedback-success"),
  //       msgFail = document.querySelector("#msg-feedback-fail");


  // // Feedback Form Submission Handler
  // feedbackForm.addEventListener("submit", async function(event) {
    
  //   event.preventDefault();

  //   const sku = document.getElementById("feedback-sku").value,
  //         user = feedbackUser.value,
  //         message = document.getElementById("feedback-message").value;

  //   try {
  //     const response = await fetch("/api/form-create-issue/", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ feedbackProduct: sku, feedbackUser: user, feedbackMessage: message, feedbackUrl: window.location.href })
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Server error: ${response.statusText}`);
  //     }

  //     // Show success message
  //     feedbackForm.classList.add("hidden");
  //     msgSuccess.classList.remove("hidden");
  //   } catch (error) {
  //     console.error("Error submitting feedback:", error);
  //     msgFail.classList.remove("hidden");
  //   }

  // });

  // // Toggle Feedback Form Visibility
  // const toggleFeedbackVisibility = (event) => {
  //   event.preventDefault();
  //   feedbackBtn?.classList.toggle("hidden");
  //   feedbackWrapper?.classList.toggle("hidden");
  //   // Optionally reset messages
  //   msgSuccess.classList.add("hidden");
  //   msgFail.classList.add("hidden");
  // };

  // // Attach event listeners for feedback buttons
  // feedbackBtn?.addEventListener("click", toggleFeedbackVisibility);
  // feedbackCancelBtn?.addEventListener("click", toggleFeedbackVisibility);

});